import { render, staticRenderFns } from "./PaymentModal.vue?vue&type=template&id=8d805f52&scoped=true&"
import script from "./PaymentModal.vue?vue&type=script&lang=tsx&"
export * from "./PaymentModal.vue?vue&type=script&lang=tsx&"
import style0 from "./PaymentModal.vue?vue&type=style&index=0&id=8d805f52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d805f52",
  null
  
)

export default component.exports